import React from 'react';
import { Timer } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n';

export const TelemetryPanel = ({ bio, ball }) => {
  const { t } = useLanguage();

  const fmtAngle = (ka) => (ka ? `${ka.min}\u00b0 \u2013 ${ka.max}\u00b0` : t('notAvailable'));

  const rows = [
    {
      id: 'execution-time',
      label: t('executionTime'),
      value: bio?.execution_time_ms ? `${bio.execution_time_ms} ms` : t('notAvailable'),
      strong: true,
    },
    { id: 'knee-left', label: t('kneeLeft'), value: fmtAngle(bio?.knee_angle_left) },
    { id: 'knee-right', label: t('kneeRight'), value: fmtAngle(bio?.knee_angle_right) },
    {
      id: 'cog',
      label: t('cogVariation'),
      value: bio?.cog_height_variation_pct != null ? `${bio.cog_height_variation_pct}%` : t('notAvailable'),
    },
    {
      id: 'ball-distance',
      label: (
        <>
          {t('ballDistance')} <span className="text-white/30">({t('aiEstimate')})</span>
        </>
      ),
      value: ball?.avg_distance_cm != null ? `~${ball.avg_distance_cm} cm` : t('notAvailable'),
    },
    {
      id: 'coverage',
      label: t('poseCoverage'),
      value: bio?.pose_coverage != null ? `${Math.round(bio.pose_coverage * 100)}%` : t('notAvailable'),
    },
  ];

  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.08 }} className="ss-card-solid p-5 md:col-span-2" data-testid="result-telemetry-panel">
      <h2 className="font-display font-bold tracking-tight text-white flex items-center gap-2">
        <Timer size={15} className="text-white/60" /> {t('telemetryTitle')}
      </h2>
      <p className="font-mono text-[10px] text-white/35 uppercase tracking-wider mb-2">{t('telemetrySub')}</p>
      <div>
        {rows.map((row) => (
          <div key={row.id} className="ss-telemetry-row">
            <span className="text-xs text-white/60">{row.label}</span>
            <span className={`font-mono text-sm tabular-nums ${row.strong ? 'text-white' : 'text-white/90'}`} data-testid={`telemetry-${row.id}`}>
              {row.value}
            </span>
          </div>
        ))}
      </div>
    </motion.div>
  );
};
